export default __webpack_public_path__ + "static/media/Christmas gifts wreath.691d4bbd.jpg";